import { render, staticRenderFns } from "./Step1Frequency.vue?vue&type=template&id=b2220254&scoped=true&"
import script from "./Step1Frequency.vue?vue&type=script&lang=js&"
export * from "./Step1Frequency.vue?vue&type=script&lang=js&"
import style0 from "./Step1Frequency.vue?vue&type=style&index=0&id=b2220254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2220254",
  null
  
)

export default component.exports